import { connect } from 'react-redux';
import { compose, withProps, withPropsOnChange, lifecycle, withState } from 'recompose';
import { withActionByRole } from '../../../common/helpers/actions';
import BalanceHistory from '../components/BalanceHistory';
import { fetchShopCashRegisterHistory, fetchBarberCashRegisterHistory } from '../actions';
import { getCashRegisterHistory } from '../selectors';
import withToggle from '../../../common/hoc/withToggle';
import { isEmptyHistoryOrFirstOpened } from '../helpers';

export default compose(
  withToggle('modal', false),
  withState('disabled', 'setDisabled', true),
  withActionByRole('fetchData', fetchShopCashRegisterHistory, fetchBarberCashRegisterHistory),
  connect(
    state => ({
      cashRegisters: getCashRegisterHistory(state),
    }),
  ),
  withProps(props => ({
    disabled: isEmptyHistoryOrFirstOpened(props.cashRegisters),
  })),
  lifecycle({
    componentDidMount() {
      this.props.fetchData();
    },
  }),
  withPropsOnChange(
    ['modalIsOn'],
    (props) => {
      if (props.modalIsOn) {
        props.fetchData();
      }
    }
  ),
)(BalanceHistory);
